const propertySearchAPIs = {
    'getCompsReport': '/excelprocessor/CompReport/Download',
    'addListToDeal': '/compsList/addListToDeal',
    'deleteListFromDeal': '/compsList/deleteDealFromList',
    'fetchDeals': '/search/dealSuggestion',
    'addListWithUser': '/sharedList/addUserShare',
    'unShareListWithUser': '/sharedList/deleteUserShare',
    'userSuggestion': '/search/userSuggestion',
    'propertySuggestion': '/search/propertySuggestion',
    'propertySearch': '/search/propertySearch',
    'exportPropertySearch': '/search/exportPropertySearch',
    'accountSuggestion': '/search/accountSuggestion',
    'prospectingSuggestion': '/search/prospectingSuggestion',
    // 'getSavedSearch': '/searchCriteria/getListsTest', 
    'getSavedSearch': '/searchCriteria/getListSavedSearch',
    'saveSavedSearch': '/searchCriteria/save',
    'deleteSavedSearch': '/searchCriteria/deletePropertySearch ',
    'getUserInfo': '/searchCriteria/getUserInfo',
    'queryPhoto': '/api/salesforce/photo/queryPhoto/'
}

export default propertySearchAPIs
